import type { WatchListTickerMap } from '@/state/dashboard'
import type { OrderFormSelection } from '@/state/order'

/** A snapshot for one visual ticker, including rows split across accounts. */
export function selectionSideQuote(
  selection: OrderFormSelection,
  tickers: WatchListTickerMap
): string | undefined {
  const rows = [
    ...selection.selectedInstruments.map((item) => ({
      symbol: item.symbol,
      exchange: item.exchange,
      side: item.side,
    })),
    ...selection.selectedOptions.map((item) => ({
      symbol: item.instrumentName,
      exchange: item.exchange,
      side: item.tradeSide ?? (item.side === 'bid' ? 'sell' : 'buy'),
    })),
  ]
  const first = rows[0]
  if (!first?.exchange) return undefined
  if (
    rows.some(
      (row) =>
        row.symbol !== first.symbol || row.exchange !== first.exchange || row.side !== first.side
    )
  ) {
    return undefined
  }
  const ticker = tickers[`${first.exchange}:${first.symbol}`]
  const price = first.side === 'sell' ? ticker?.bestBidPrice : ticker?.bestAskPrice
  return price && Number.isFinite(Number(price)) && Number(price) > 0 ? price : undefined
}
